/**
 * 初始化pageLoad埋点函数
 * @param stReportSdk {DcReporter}
 * @param report
 * @param getDiffRouteTime
 * @return {Function}
 */
export default function initTrackPageLoad(stReportSdk, report, getDiffRouteTime) {
  return function() {
    stReportSdk.trackPageLoad();

    report({
      eventId: 'loadpagestart', //事件ID
      eventDesc: '页面开始加载', //事件描述
      eventBody: {} //事件体
    });
  };
}
